import { render } from "./OptimiseShelfDesign.vue?vue&type=template&id=32e3c3f2&scoped=true&ts=true"
import script from "./OptimiseShelfDesign.vue?vue&type=script&lang=ts"
export * from "./OptimiseShelfDesign.vue?vue&type=script&lang=ts"

import "./OptimiseShelfDesign.vue?vue&type=style&index=0&id=32e3c3f2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e3c3f2"]])

export default __exports__